export const HierarchicalListSummaryName = 'hierarchicalListSummaryComponent';
